import { StyledCardContainer } from "pages/OrderUpdate/components/Update/styled";
import { IDirectPayLinkPublicConfig } from "types/DirectPayLink.d";

import { PatientInfo } from "./PatientInfo";
import { TotalAmount } from "./TotalAmount";
import { VisitInfo } from "./VisitInfo";

interface IDirectCreateProps {
  linkConfig?: IDirectPayLinkPublicConfig | null;
}

export function DirectCreate({ linkConfig }: IDirectCreateProps) {
  return (
    <StyledCardContainer className="mb-3">
      <PatientInfo linkConfig={linkConfig} />
      <div className="formgrid grid w-100">
        <VisitInfo linkConfig={linkConfig} />
        <TotalAmount linkConfig={linkConfig} />
      </div>
    </StyledCardContainer>
  );
}
